import { Link } from "react-router-dom";
import React from "react";

export default function PageLinks({ dark, links = [] }) {
  return (
    <section className={`breadcrumbs ${dark ? "bg-black" : ""} `}>
      <div className="container">
        <div className="row">
          <div className="col-auto">
            <div className="breadcrumbs__content">
              {links.map((link, index) => (
                <div
                  className={`breadcrumbs__item ${dark ? "text-white " : ""} `}
                  key={index}
                >
                  <Link to={link.target}>{link.title}</Link>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
              
  